module.exports = __webpack_public_path__ + "img/change.ab878a77.svg";